import React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

interface GaraazAlertDialogue {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  leftBtnText?: string;
  submitBtnText?: string;
  onSubmitBtn: () => void;
  alertBodyText: any;
  alertDialogueHeaderText: string;
  submitBtnColorScheme?: string;
  cancelBtnColorScheme?: string;
  isSubmitBtnDisabled?: boolean;
  isCentered?: boolean;
}

function GaraazAlertDialogue(props: GaraazAlertDialogue) {
  const cancelRef = React.useRef(null);

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={props.isOpen}
      onClose={props.onClose}
      returnFocusOnClose={false}
      isCentered={props.isCentered}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {props.alertDialogueHeaderText}
          </AlertDialogHeader>
          <AlertDialogBody>{props.alertBodyText}</AlertDialogBody>
          <AlertDialogFooter>
            <Button 
              bg = {props.cancelBtnColorScheme || "gray.100"}
              ref={cancelRef} onClick={props.onClose}>
              {props.leftBtnText || "Cancel"}
            </Button>
            <Button
              colorScheme={props.submitBtnColorScheme || "blue"}
              bg={props.submitBtnColorScheme || "blue.500"}
              onClick={props.onSubmitBtn}
              ml={3}
              isDisabled={props.isSubmitBtnDisabled}
            >
              {props.submitBtnText || "Save"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export default GaraazAlertDialogue;
